import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import ContentTypeBadge from '../../../components/ui/ContentTypeBadge';
import { toArabicDigits, withArabicDigits, formatDateYYYYMMDD } from '../../../utils/numbers';

const PublishedArticleCard = ({ article, onView, onEdit }) => {
  const getCircleColor = (circle) => {
    const colors = {
      'الروح': 'bg-primary/20 text-primary',
      'الأدب': 'bg-accent/20 text-accent',
      'الشعر': 'bg-success/20 text-success',
      'الفلسفة': 'bg-warning/20 text-warning',
      'البصريات': 'bg-secondary/20 text-secondary',
      'الصوت': 'bg-primary/20 text-primary',
      'التراث': 'bg-accent/20 text-accent',
      'التصوف': 'bg-success/20 text-success'
    };
    return colors?.[circle] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300 group">
      {article?.coverImage && (
        <div className="w-full h-40 md:h-48 lg:h-56 overflow-hidden">
          <Image
            src={article?.coverImage}
            alt={article?.coverImageAlt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      )}
      <div className="p-4 md:p-5 lg:p-6 space-y-3 md:space-y-4">
        <div className="space-y-2">
          <div className="flex flex-wrap items-center gap-2">
            <ContentTypeBadge type={article?.type} size="sm" />
            <span className={`inline-block px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium ${getCircleColor(article?.circle)}`}>
              {article?.circle}
            </span>
          </div>
          <h3
            className="text-base md:text-lg lg:text-xl font-bold text-foreground line-clamp-2 group-hover:text-primary transition-colors cursor-pointer"
            onClick={() => onView(article?.id)}
          >
            {article?.title}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {article?.excerpt}
          </p>
        </div>
        
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="Eye" size={14} className="md:w-4 md:h-4" />
            <span>{toArabicDigits(article?.views)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Heart" size={14} className="md:w-4 md:h-4" />
            <span>{toArabicDigits(article?.claps)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="MessageCircle" size={14} className="md:w-4 md:h-4" />
            <span>{toArabicDigits(article?.comments)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Share2" size={14} className="md:w-4 md:h-4" />
            <span>{toArabicDigits(article?.shares)}</span>
          </div>
        </div>
        
        <div className="flex items-center gap-1 text-xs md:text-sm text-muted-foreground">
          <Icon name="Calendar" size={14} className="md:w-4 md:h-4" />
          <span>نُشر في <span dir="ltr">{formatDateYYYYMMDD(article?.publishedDate ?? '')}</span></span>
        </div>
        
        <div className="flex gap-2 pt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onView(article?.id)}
            iconName="Eye"
            iconPosition="right"
            className="flex-1"
          >
            عرض
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(article?.id)}
            iconName="Edit"
            iconPosition="right"
            className="flex-1"
          >
            تعديل
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PublishedArticleCard;